import React from 'react';
import Modal from '../../component/Inc/Modal';
function PopRefundApproval(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} popSize="s" type="pop_refund_approval">
      <h2 className="pop_tit">환불승인</h2>
      <div className="content_container scroll">
        <div className="com_board_box">
          <div className="board_item">
            <div className="info center">
              <span className="tit">환불 요청일 </span>
              <span className="cont">2024, 05, 12 </span>
              <button className="com_btn gray xxs right_item">취소</button>
            </div>
            <div className="info">
              <span className="tit">학생명</span>
              <span className="cont">홍길동132 ㅣ 010-1324-3214</span>
            </div>
            <hr className="com_divider" />
            <div className="info">
              <span className="tit">과목</span>
              <div className="cont full">
							수학, 영어
             
                <table className="com_board_list type_row">
                  <colgroup>
                    <col width="90" />
                    <col width="auto" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>단말기</th>
                      <td>78,000</td>
                    </tr>
                    <tr>
                      <th>카드</th>
                      <td>45,000</td>
                    </tr>
                    <tr>
                      <th>가상계좌</th>
                      <td>78,000</td>
                    </tr>
                    <tr>
                      <th>현금</th>
                      <td>123,000</td>
                    </tr>
                    <tr>
                      <th>위약금</th>
                      <td>-123,000</td>
                    </tr>
                    <tr>
                      <th>수수료</th>
                      <td>수학, 영어</td>
                    </tr>
                    <tr>
                      <th>총 환불 금액</th>
                      <td className="com_blue_txt">798,000</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="info">
              <span className="tit">카드 환불 금액 </span>
              <span className="cont">45,000</span>
            </div>
            <div className="info">
              <span className="tit">무통장 환불 금액 </span>
              <span className="cont">78,000</span>
            </div>
            <div className="info">
              <span className="tit">하나은행 홍길동 </span>
              <span className="cont">13224-3214-3214</span>
            </div>
            <div className="info">
              <span className="tit">환불 사유 </span>
              <span className="cont">그동안 잦은 지각으로 학부모가 기분이 좋지 않았나 봅니다.</span>
            </div>
            <hr className="com_divider" />
            <div className="info center">
              <span className="tit">2024,05,12 ㅣ 12:30 </span>

              <span className="cont">
                <strong className="com_bk_txt">홍길동</strong>
                <strong className="com_red_txt">승인 불가</strong>
              </span>
            </div>
            <div className="info center">
              <span className="tit">2024,05,12 ㅣ 12:30 </span>
              <span className="cont">
                <strong className="com_bk_txt">홍길동</strong>
                <strong className="com_blue_txt">승인 완료</strong>
              </span>
            </div>
          </div>
        </div>
        <div className="com_radio_wrap">
          <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
          <label htmlFor="rdo01">승인</label>
          <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
          <label htmlFor="rdo02">승인 불가</label>
        </div>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">확인</button>
      </div>
    </Modal>
  );
}

export default PopRefundApproval;
